module.exports = __webpack_public_path__ + "img/Problem.44eeeb52.svg";